import styled from 'styled-components';

export default styled.ul`
  list-style-type: none;
`;